import { IBreadCrumbsViewModel } from 'Types/Litium';

interface BreadCrumbsProps extends IBreadCrumbsViewModel {
    margin?: string;
    backgroundColor?: string;
}

const BreadCrumbs = ({
    contentLinks,
    margin,
    backgroundColor,
}: BreadCrumbsProps) => (
    <div className="flex h-full w-full">
        <nav aria-label="breadcrumbs" className={`w-full ${backgroundColor}`}>
            <ol
                className={`mx-auto flex max-w-content flex-wrap justify-start px-4.5 pb-1 pt-2 lg:justify-start lg:px-14 lg:pb-2 lg:pt-3 ${
                    margin ?? ''
                }`}
            >
                {contentLinks.map((crumb, index) => (
                    <li className="font-roboto text-sm" key={index}>
                        <a
                            className={` ${
                                crumb.disabled ? 'pointer-events-none' : ''
                            } ${
                                crumb.isSelected ? 'font-medium' : 'font-light'
                            }`}
                            aria-current={
                                crumb.isSelected ? 'location' : undefined
                            }
                            href={crumb.url}
                        >
                            {crumb.name}
                        </a>
                        {index !== contentLinks.length - 1 && (
                            <span
                                className="mx-1 font-roboto text-sm"
                                aria-hidden="true"
                            >
                                /
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    </div>
);

export default BreadCrumbs;
